import ReactDOM from "react-dom/client";
import React from "react";

import App from "./App";
import "./index.css";

ReactDOM.createRoot(document.querySelector("#root")).render(<App />);
